/* Minimal TikTok Pixel wrapper */

import { loadTikTokPixelBaseCode } from "./tiktokPixelBase";

declare global {
  interface Window {
    ttq?: any;
  }
}

// Build-time value (CRA inlines REACT_APP_*): changing it needs a rebuild and
// deploy. Empty means no TikTok script is loaded and every call is a no-op.
const PIXEL_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID;

/**
 * Loads the pixel once with TikTok's base code and reports the landing page
 * view. Route changes are not tracked here: the pixel's default
 * historyObserver already reports a page view on every SPA URL change, so an
 * explicit ttq.page() per route would double count.
 *
 * If the script is blocked, the base code's queue stub stays in place and
 * later calls queue harmlessly.
 */
export const initTikTokPixel = () => {
  try {
    if (!PIXEL_ID || typeof window === "undefined" || window.ttq) return;
    loadTikTokPixelBaseCode(PIXEL_ID);
  } catch (error) {
    console.warn("Error loading TikTok Pixel:", error);
  }
};

/**
 * Pass the same id Meta gets (fb_event_id). The pricing click and the checkout
 * page mount both report the checkout; TikTok drops the repeat because the
 * event + event_id pair matches.
 */
export const trackTikTokInitiateCheckout = (eventId: string) => {
  try {
    if (typeof window === "undefined" || !window.ttq) return;
    window.ttq.track("InitiateCheckout", {}, { event_id: eventId });
  } catch (error) {
    console.warn("Error tracking TikTok InitiateCheckout:", error);
  }
};
